import errorMessages from 'consts/errorMessageConsts';
import {
  CHIME_APPLICATION_TOKEN,
  CHIME_SESSION_TOKEN,
} from 'consts/storageConsts';

import loggerHelper, { LOG_LEVELS } from 'utils/logger/loggerHelper';
import { setValueInStorage } from 'utils/storage/storageHelper';

/**
 * This only triggers for cases when server returns response
 */
export default function handleServerResponse(res) {
  /** The MAS flow will no longer use Rails default session cookies.
   * It will now pass the session key through a custom header,
   * and expect the key in the request headers when hitting
   * authenticated endpoints. **/

  const chimeSessionKey =
    res && res.headers && res.headers.get(CHIME_SESSION_TOKEN);
  const chimeApplicationToken =
    res && res.headers && res.headers.get(CHIME_APPLICATION_TOKEN);

  if (chimeSessionKey) {
    setValueInStorage(CHIME_SESSION_TOKEN, chimeSessionKey);
  }

  if (chimeApplicationToken) {
    setValueInStorage(CHIME_APPLICATION_TOKEN, chimeApplicationToken);
  }

  return res.json().then(resData => {
    const newResData = resData || {};

    if (res.status !== 200 && res.status !== 201) {
      newResData.errorCode = res.status;
      newResData.error =
        newResData.error || errorMessages.GENERAL_ERROR_MESSAGE;

      if (newResData.errorCode !== 401) {
        loggerHelper({
          message: newResData.error,
          info: newResData,
        });
      }
    } else {
      newResData.status = res.status;
    }

    return newResData;
  });
}

export function catchRequestError(errorResponse, errorMessage) {
  loggerHelper({
    level: LOG_LEVELS.ERROR,
    message: errorMessage || 'Request error during enrollment',
    info: errorResponse,
  });

  const error = new Error(errorMessages.GENERAL_ERROR_MESSAGE);

  return Promise.reject(error);
}
